import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import BlockHeader from 'components/common/BlockHeader';
import Image from 'components/common/Image';
import i18n from 'i18n';
import imgCardsPC1x from 'assets/images/PC/@1x/img_cards.png';
import imgCardsPC2x from 'assets/images/PC/@2x/img_cards.png';
import imgCardsSP2x from 'assets/images/SP/@2x/img_cards.png';
import imgCardsSP3x from 'assets/images/SP/@3x/img_cards.png';

const Credit = ({ className }) => (
  <div className={className}>
    <BlockHeader>{i18n.t('about:payment:credit.header')}</BlockHeader>
    <p className="description">{i18n.t('about:payment:credit.description')}</p>

    <div className="cards">
      <Image
        pc1x={imgCardsPC1x}
        pc2x={imgCardsPC2x}
        sp2x={imgCardsSP2x}
        sp3x={imgCardsSP3x}
        alt="img_card1"
      />
    </div>
    <ul>
      {i18n
        .t('about:payment:credit.additions', { returnObjects: true })
        .map((addition, i) => (
          <li key={i}>{addition}</li>
        ))}
    </ul>
    <p className="tips">{i18n.t('about:payment:credit.tips')}</p>
  </div>
);

const commonStyle = css`
  .description {
    color: ${Colors.black1};
    margin-bottom: 16px;
  }

  .cards {
    margin: 16px 0 24px;
  }

  ul {
    padding-left: 13px;
    margin-bottom: 0;

    li {
      color: ${Colors.black1};
      list-style: none;
      position: relative;
      white-space: pre-line;

      &:before {
        content: '●';
        position: absolute;
        left: -11px;
        font-size: 7px;
      }
    }
  }

  .tips {
    position: relative;
    color: ${Colors.black1};
    padding-left: 20px;

    &:before {
      content: '※';
      position: absolute;
      left: 0;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .description {
    ${FontStyles.text8};
  }

  picture: first-child {
    img {
      margin-right: 32px;
    }
  }

  ul {
    li {
      ${FontStyles.text8};
    }
  }

  .tips {
    ${FontStyles.text10};
    margin-top: 8px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .description {
    ${FontStyles.text6};
  }

  picture: first-child {
    img {
      margin-right: 16px;
    }
  }

  ul {
    li {
      ${FontStyles.text6};
    }
  }

  .tips {
    ${FontStyles.text8};
    margin-top: 6px;
  }
`;

export default applyStyles(Credit)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/About/Payment/components/Credit.js